// src/next/server.ts
import { cookies } from "next/headers";
var getNextServerCookiesStorage = (options = {}) => {
  const secure = options.secure ?? true;
  const cache = /* @__PURE__ */ new Map();
  return {
    getItem(key) {
      return cache.get(key) ?? cookies().get(key)?.value ?? null;
    },
    removeItem(key) {
      cache.delete(key);
      cookies().delete(key);
    },
    setItem(key, value) {
      try {
        cache.set(key, value);
        const expires = tryGetExpFromJwt(value);
        cookies().set(key, value, { httpOnly: true, sameSite: "lax", secure, expires });
      } catch {
      }
    }
  };
};
var tryGetExpFromJwt = (token) => {
  try {
    const exp = JSON.parse(atob(token.split(".")[1] ?? "")).exp;
    const nowInSeconds = Date.now() / 1e3;
    if (exp && typeof exp === "number" && exp > nowInSeconds) {
      return new Date(exp * 1e3);
    }
  } catch {
  }
  return void 0;
};
export {
  getNextServerCookiesStorage
};
